import React from 'react'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import PropTypes from 'prop-types'
import Link from '../Link/index'
import { H2 } from '../Heading/index'
import { TYPE_CONTENT_VIDEO } from '../../services/content-type/index'
import { CLICK_TO_DETAILS_PAGE_GA4_EVENT } from '../../services/event-tracking/index'

const TitleVideo = (props) => {
  const {
    video,
    linkClass,
    titleClass,
    hasHeader,
  } = props
  const videoPath = video.get('path', null)
  const videoTitle = video.getIn(['data', 'title'])
  const videoDetailsEventData = CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep({
    content_id: video.getIn(['data', 'id']),
    content_name: video.getIn(['data', 'title']),
    content_type: TYPE_CONTENT_VIDEO,
    media_id: video.getIn(['data', 'feature', 'id']),
    media_language: video.getIn(['data', 'videoLang']),
    is_featured_media: true,
    parent_series_name: video.getIn(['data', 'seriesTitle']),
    parent_series_id: video.getIn(['data', 'seriesId']),
    ui_location: hasHeader ? 'Video Player' : 'End Screen',
    ui_element: 'Title',
  })

  return (
    <Link
      to={videoPath}
      className={`video-title__link-container ${linkClass}`}
      ga4EventData={videoDetailsEventData}
    >
      {hasHeader
        ? <H2 inverted className={titleClass}>{videoTitle}</H2>
        : <div className={titleClass}>{videoTitle}</div>
      }
    </Link>
  )
}

TitleVideo.propTypes = {
  video: PropTypes.object,
  linkClass: PropTypes.string,
  titleClass: PropTypes.string,
  hasHeader: PropTypes.bool,
}

export default compose(
  connectRedux(
    (state) => {
      const { video } = state
      return {
        video,
      }
    },
  ),
)(TitleVideo)
